// jvector map
import "jvectormap";
import "jvectormap/tests/assets/jquery-jvectormap-world-mill-en";
import "jvectormap/jquery-jvectormap.css";
